import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Project } from './project';

export interface ProjectsStore {
  loaded$: Observable<boolean>;
  allItems$: Observable<Project[]>;
  selectedItem$?: Observable<Project>;

  load(): Observable<Project[]>;
  addItem?(project: Project): void;
  editItem(project: Project): void;
  deleteItem(project: Project): void;
  editOrAddSuccess(): Observable<unknown>;
}

export const PROJECTS_STORE = new InjectionToken<ProjectsStore>(
  'PROJECTS_STORE',
);
